<template>
  <div style="width: 900px;" id="hmbPrintArea">
    <h3 style="display: flex;justify-content: center; font-weight: 500; font-size: 30px;">“深圳惠民保”理赔结算单</h3>
    <div style="width: 100%;">
      <table border="1" cellpadding="0" cellspacing="0" style="width:100%;">
        <tr>
          <td style="width: 12%;">姓名</td>
          <td style="width: 12%;">{{tableData.setlinfo.psnName || ''}}</td>
          <td style="width: 10%;">性别</td>
          <td style="width: 10%;">{{tableData.setlinfo.gend || ''}}</td>
          <td style="width: 10%;">出生日期</td>
          <td style="width: 11%;">{{tableData.setlinfo.brdy || ''}}</td>
          <td style="width: 11%;">机构名称</td>
          <td colspan="2" style="width: 24%;">{{tableData.setlinfo.fixmedinsName || ''}}</td>
        </tr>
        <tr>
          <td>结算号</td>
          <td colspan="5">{{tableData.setlinfo.setlId || ''}}</td>
          <td>就医登记号</td>
          <td colspan="2">{{tableData.setlinfo.mdtrtId || ''}}</td>
        </tr>
        <tr>
          <td>人员类别</td>
          <td>{{tableData.setlinfo.psnType || ''}}</td>
          <td>业务类别</td>
          <td colspan="3">{{tableData.setlinfo.medType || ''}}</td>
          <td>医保结算级别</td>
          <td colspan="2">{{tableData.setlinfo.hospLv || ''}}</td>
        </tr>
        <tr>
          <td>联系电话</td>
          <td colspan="5"></td>
          <td>身份证号</td>
          <td colspan="2">{{tableData.setlinfo.certno || ''}}</td>
        </tr>
        <tr>
          <td>入院第一诊断</td>
          <td colspan="2"></td>
          <td colspan="2">出院第一诊断</td>
          <td colspan="2"></td>
          <td colspan="0.5" style="width: 17%;">深圳惠民保参保状态</td>
          <td>{{tableData.expContent ? tableData.expContent.hmbInsuFlag == 1 ? '参保' : '未参保' : '未参保'}}</td>
        </tr>
        <tr>
          <td>入院日期</td>
          <td colspan="5">{{tableData.setlinfo.begndate || ''}}</td>
          <td colspan="1">出院日期</td>
          <td colspan="2">{{tableData.setlinfo.enddate || ''}}</td>
        </tr>
        <tr>
          <td>发票金额</td>
          <td colspan="8">{{tableData.setlinfo.medfeeSumamt || ''}}</td>
        </tr>
        <tr>
          <td colspan="9">深圳惠民保待遇一（医保目录内费用保障）</td>
        </tr>
        <tr>
          <td colspan="3">费用类别</td>
          <td colspan="4">金额（元）</td>
          <td colspan="2">备注</td>
        </tr>
        <tr>
          <td colspan="3">本年度个人负担费用累计</td>
          <td colspan="4">{{tableData.expContent ? tableData.expContent.psnAmtCumOne : '0'}}</td>
          <td colspan="2" rowspan='4'><div>免赔额：1.6万元</div><div>赔付比例：80%</div></td>
        </tr>
        <tr>
          <td colspan="3">本次个人负担费用</td>
          <td colspan="4">{{tableData.expContent ? tableData.expContent.psnAmtOne : '0'}}</td>
        </tr>
        <tr>
          <td colspan="3">本年度累计报销费用</td>
          <td colspan="4">{{tableData.expContent ? tableData.expContent.reimPayCumOne : '0'}}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销</td>
          <td colspan="4">{{tableData.expContent ? tableData.expContent.reimPayOne : '0'}}</td>
        </tr>
        <tr>
          <td colspan="9">深圳惠民保待遇二（住院自费合规药品和检验检查费用保障）</td>
        </tr>
        <tr>
          <td colspan="3">费用类别</td>
          <td colspan="4">金额（元）</td>
          <td colspan="2">备注</td>
        </tr>
        <tr>
          <td colspan="3">本年度个人负担费用累计</td>
          <td colspan="4">{{ getValue('psnAmtCumTwo') }}</td>
          <td colspan="2" rowspan='4'><div>免赔额：1.6万元</div><div>赔付比例：70%</div></td>
        </tr>
        <tr>
          <td colspan="3">本次个人负担费用</td>
          <td colspan="4">{{ getValue('psnAmtTwo') }}</td>
        </tr>
        <tr>
          <td colspan="3">本年度累计报销费用</td>
          <td colspan="4">{{ getValue('reimPayCumTwo') }}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销</td>
          <td colspan="4">{{ getValue('reimPayTwo') }}</td>
        </tr>
        <tr>
          <td colspan="9">深圳惠民保待遇三（门诊自费合规药品保障）</td>
        </tr>
        <tr>
          <td colspan="3">费用类别</td>
          <td colspan="4">金额（元）</td>
          <td colspan="2">备注</td>
        </tr>
        <tr>
          <td colspan="3">本年度个人负担费用累计</td>
          <td colspan="4">{{ getValue('psnAmtCumThree') }}</td>
          <td colspan="2" rowspan='4'><div>免赔额：4万元</div><div>赔付比例：50%</div></td>
        </tr>
        <tr>
          <td colspan="3">本次个人负担费用</td>
          <td colspan="4">{{ getValue('psnAmtThree') }}</td>
        </tr>
        <tr>
          <td colspan="3">本年度累计报销费用</td>
          <td colspan="4">{{ getValue('reimPayCumThree') }}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销</td>
          <td colspan="4">{{ getValue('reimPayThree') }}</td>
        </tr>
        <tr>
          <td colspan="9">深圳惠民保待遇四（罕见病自费药品费用保障）</td>
        </tr>
        <tr>
          <td colspan="3">费用类别</td>
          <td colspan="4">金额（元）</td>
          <td colspan="2">备注</td>
        </tr>
        <tr>
          <td colspan="3">本年度个人负担费用累计</td>
          <td colspan="4">{{ getValue('psnAmtCumFour') }}</td>
          <td colspan="2" rowspan='4'><div>免赔额：1.6万元</div><div>赔付比例：50%/60%/70%</div></td>
        </tr>
        <tr>
          <td colspan="3">本次个人负担费用</td>
          <td colspan="4">{{ getValue('psnAmtFour') }}</td>
        </tr>
        <tr>
          <td colspan="3">本年度累计报销费用</td>
          <td colspan="4">{{ getValue('reimPayCumFour') }}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销</td>
          <td colspan="4">{{ getValue('reimPayFour') }}</td>
        </tr>
        <tr>
          <td colspan="9">深圳惠民保待遇五（港澳药械通费用保障）</td>
        </tr>
        <tr>
          <td colspan="3">费用类别</td>
          <td colspan="4">金额（元）</td>
          <td colspan="2">备注</td>
        </tr>
        <tr>
          <td colspan="3">本年度个人负担费用累计</td>
          <td colspan="4">{{ getValue('psnAmtCumFive') }}</td>
          <td colspan="2" rowspan='4'><div>免赔额：1.6万元</div><div>赔付比例：50%</div></td>
        </tr>
        <tr>
          <td colspan="3">本次个人负担费用</td>
          <td colspan="4">{{ getValue('psnAmtFive') }}</td>
        </tr>
        <tr>
          <td colspan="3">本年度累计报销费用</td>
          <td colspan="4">{{ getValue('reimPayCumFive') }}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销</td>
          <td colspan="4">{{ getValue('reimPayFive') }}</td>
        </tr>
        <tr>
          <td colspan="3">本次报销总计（元）</td>
          <td colspan="7">{{ getValue('hifobPay') }}</td>
        </tr>
      </table>
    </div>
    <h3 style="display: flex;justify-content: flex-start; font-weight: 500; font-size: 20px;">备注：“深圳惠民保”基金支出列为结算单“大额基金”支出</h3>
  </div>
</template>
<script>
export default {
  name: "shenzhenHYBModel",
  data() {
    return {
      tableData: {
        setlinfo: {},
        expContent: {},
      },
    };
  },
  methods: {
    handlePrint() {
      let dom = document.querySelector('#hmbPrintArea');
      dom.style.display = 'block';
      this.$print(dom);
    },
    getValue(key) {
      return this.tableData.expContent ? this.tableData.expContent[key] || '0' : '0';
    },
  },
};
</script>
<style lang="less" scoped>
#hmbPrintArea td {
  text-align: center;
  height: 24px;
}

.noBorder {
  // border: none;
  border-color: red;
}

.cardInfoArea {
    width: 100%;
    margin-bottom: 10px;
    background-color: #F1F5F8;
    padding-left: 24px;
    .everyInfo {
      display: inline-block;
      margin-top: 10px;
      width: 30%;
    }
  }
</style>
